<template lang="html">
  <div class="pkg-main" :class="[isActive, isTop, timeWordClass, isDelete]">
    <div class="time-word" v-if="timeWord">
      <div class="time-word-cell">
        <span>{{ timeWord }}</span>
      </div>
      <div class="time-word-shadow"></div>
    </div>
    <div class="pkg-box">
      <div class="pkg" :style="{fontWeight: weight}">
        <div class="pkg-img">
          <avatar
            v-if="imgUrl===''"
           :username="name"
           :size="32"
           color="#fff"
          >
          </avatar>
          <img :src="imgUrl" v-if="imgUrl!==''" alt=''>
        </div>
        <div class="pkg-name" @click="filesList(id, state);addActive()">
          <div class="name" :title="name">
            {{name}}
          </div>
          <div class="num">
            {{nameNum}}
          </div>
        </div>
        <div class="pkg-title" @click="filesList(id, state);addActive()">
            {{title}}
            <span class="notes" v-if="notesShow">- {{ notes }}</span>
        </div>
        <div class="pkg-percent">
          <el-progress
            v-show = "percent !== 100"
            type="circle"
            :show-text = "false"
            :width="18" :percentage="percent" :stroke-width="3">
          </el-progress>
          <i class="el-icon-circle-check"
            style="font-size:18px;color:#20a0ff"
            v-show="percent === 100">
          </i>
        </div>
        <div v-show="fileNum === 1" class="pkg-size" :title="size">
          {{ fileNum }}{{message.Sl111.l0}}<span v-if="fileNum !== recordNum">({{recordNum}})</span> | {{ size }}
        </div>
        <div v-show="fileNum !== 1" class="pkg-size" :title="size">
          {{ fileNum }}{{message.Sl111.l1}}<span v-if="fileNum !== recordNum">({{recordNum}})</span> | {{ size }}
        </div>
        <div class="pkg-time" @click="filesList(id, state);addActive()">{{time}}</div>
        <el-popover
          ref="popover"
          placement="top"
          width="160"
          v-model="visible"
          :disabled="dis.pkg"
          :title="message.Sl115">
          <div class="po-name">{{title}}</div>
          <p></p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="visible = false">{{message.Fl101}}</el-button>
            <el-button type="primary" size="mini" @click="download (id)">{{message.Fl100}}</el-button>
          </div>
        </el-popover>
        <div class="more" :style="{display: display}">
          <i v-if="state === 'download'&&isDelete ===''" class="material-icons icon download appDownload" :class="appActive" @click="appDownloadPkg" v-popover:popover :title="message.Sl115">
            file_download
          </i>
          <el-popover
            ref="popover-a"
            placement="top"
            width="160"
            v-model="visibleA"
            :title="message.Sl117">
            <div class="po-name" style="color:#d43f3a">{{title}}</div>
            <p></p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="visibleA = false">{{message.Fl101}}</el-button>
              <el-button size="mini" type="danger" @click="deletePkg (id)">{{message.Fl100}}</el-button>
            </div>
          </el-popover>
          <el-popover
            ref="popover-d"
            @show="getUserlist()"
            placement="bottom"
            width="231"
            v-model="visibleD"
            :title="message.Al120">
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="visibleD = false">{{message.Fl101}}</el-button>
              <el-button size="mini" type="danger" @click="addUser()">{{message.Fl100}}</el-button>
            </div>
            <p></p>
            <el-select v-model="addUserList" multiple style="width:100%">
              <el-option
                v-for="user in userList"
                :key="user.id"
                :label="user.name"
                :value="user.id"
              >
              </el-option>
            </el-select>
          </el-popover>
          <i v-if="isDelete ===''&&state !== 'download'" v-popover:popover-d class="material-icons icon download">group_add</i>
          <i v-if="isDelete ===''" class="material-icons icon delete" v-popover:popover-a :title="message.Sl117">
            delete
          </i>
          <el-popover
            @hide="scheduleShow(false)"
            v-model="visibleF"
            ref="popover-c"
            placement="bottom"
            width="320"
            trigger="click">
            <div class="info-main">
              <div class="cell">
                <div class="name">
                  {{tableData[1].key}}:
                </div>
                <div class="value">
                  <span v-if="tableData[1].value === '-'">
                    N/A
                  </span>
                  <span v-if="tableData[1].value !== '-'">
                    {{tableData[1].value}}
                  </span>
                </div>
              </div>
              <div class="cell">
                <div class="name">
                  {{tableData[6].key}}:
                </div>
                <div class="value">
                  {{tableData[6].value}}
                </div>
              </div>
              <div class="cell" v-if="state === 'upload'">
                <!-- <div class="name">
                  {{}}
                </div> -->
                <div class="value">
                  {{message.Sl211}} ({{tableData[4].key}}: {{tableData[4].value}}):
                </div>
              </div>
              <div class="schedule" v-if="state === 'upload'">
                <comp-schedule
                  :id = "this.id"
                  :show= "this.visibleF&&this.state === 'upload'"
                ></comp-schedule>
              </div>
              <!-- <el-table
                :data="tableData"
                :show-header="false"
                border
                style="100%"
              >
                <el-table-column
                  prop="key"
                >
                </el-table-column>
                <el-table-column
                  prop="value"
                >
                </el-table-column>
              </el-table>
              <div class="check" v-if="state === 'upload'">
                <span @click="scheduleShow(true)">{{message.Sl210}}</span>
              </div>
            </div>
            <comp-schedule
              :id = "this.id"
              :show= "this.schedule"
              @scheduleBack="scheduleShow(false)"
            ></comp-schedule> -->
            </div>
          </el-popover>
          <span v-popover:popover-c class="material-icons icon info">
            info
          </span>
          <el-popover
            ref="popover-e"
            @show="getSharelist()"
            placement="bottom"
            width="320"
            v-model="visibleE"
            :title="message.Sl207">
            <div
            v-for="(share, index) in shareList"
            :key="index"
            class="share-cell">
            &nbsp;&nbsp;{{share.name}}:<br/>
              <el-input
                style="z-index:2"
                v-model="share.url"
                size="medium"
              >
                <el-button
                  :buttonIndex="index"
                  slot="append"
                  v-clipboard:copy="share.url"
                  v-clipboard:success="copyTip"
                >
                  {{message.Sl208}}
               </el-button>
              </el-input>
              <el-tooltip class="item" v-model="share.tip" effect="dark" :content="tipWord" placement="bottom">
                <div class="tip"></div>
              </el-tooltip>
            </div>
            <span v-if="this.shareList.length===0" style="width:100%;text-algin:center">{{message.Sl114}}</span>
          </el-popover>
          <i v-if="isDelete ===''&&state !== 'download'" v-popover:popover-e class="material-icons icon download">share</i>
          <div class="info-box">
          </div>
        </div>
      </div>
      <div class="pkg-more">
        <div class="check-files-list" v-show="checkedList.length !== 0">
          <el-popover
            ref="popover-b"
            placement="top"
            width="160"
            :disabled="dis.files"
            v-model="visibleB"
            :title="message.Sl116">
            <div class="po-name-a">{{message.Sl112L1}}<span style="color:#0291cf;">{{ checkedList.length }}</span>{{message.Sl112L2}}?</div>
            <p></p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="visibleB = false">{{message.Fl101}}</el-button>
              <el-button type="primary" size="mini" @click="downloadFiles">{{message.Fl100}}</el-button>
            </div>
          </el-popover>
          <div class="button-download appDownload" :class="appActive" @click="appDownloadFiles" v-popover:popover-b>
            <span class="icon">&#xe820;</span>
            {{message.Sl116}} ({{ checkedList.length }})
          </div>
          <el-button @click="checkedList = []" style="float:left;margin:10px 0 0 20px " type="text">{{message.Sl113}}</el-button>
        </div>
        <div class="box-notes" :title="notes" v-show="notes !==''">
          {{message.Sl118}}：{{ notes }}
        </div>
        <div class="box-notes" :title="notes" v-show="notes ===''">
          {{message.Sl118}}：<em>{{message.Sl114}}</em>
        </div>
        <div class="fileList" v-loading="filesLoading">
          <comp-files
            v-for = "file in files"
            :key = "file.id"
            :id="file.id"
            :name="file.name"
            :size="file.size"
            :percent="file.percent"
            :fileState="file.state"
            :checkedList="checkedList"
            @cellChecked="checkedFiles"
            :isDelete="isDelete"
          >
          </comp-files>
        </div>
        <div class="page" v-show="total > 8">
          <el-pagination
            small
            layout="prev, pager, next"
            :page-size="8"
            :total="total"
            :current-page.sync="num"
            @current-change="pageList()"
            >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from 'vue-avatar'
import CompFiles from '@/components/box/pkg/file.vue'
import CompSchedule from '@/components/box/pkg/schedule.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    Avatar,
    CompFiles,
    CompSchedule
  },
  computed: {
    ...mapGetters({
      app: 'app',
      space: 'space'
    }),
    tableData: function () {
      if (this.type === 'receiver') {
        var percent = this.uploadPercent
      } else {
        percent = parseInt(this.percent)
      }
      var data = [
        {
          key: this.$lang.ui.system.pkgInfo.l00,
          value: this.time
        },
        {
          key: this.$lang.ui.system.pkgInfo.l01,
          value: this.expire.time
        },
        {
          key: this.$lang.ui.system.pkgInfo.l02,
          value: this.size
        },
        {
          key: this.$lang.ui.system.pkgInfo.l03,
          value: this.fileNum
        },
        {
          key: this.$lang.ui.system.pkgInfo.l04,
          value: this.downloadTimes
        },
        {
          key: this.$lang.ui.system.pkgInfo.l05,
          value: this.name
        },
        {
          key: this.$lang.ui.system.pkgInfo.l06,
          value: percent + '%'
        }
      ]
      return data
    }
  },
  watch: {
    visible () {
      if (this.visible) {
        this.display = 'block'
      } else {
        this.display = 'none'
      }
    },
    visibleA () {
      if (this.visibleA) {
        this.display = 'block'
      } else {
        this.display = 'none'
      }
    },
    visibleD () {
      if (this.visibleD) {
        this.display = 'block'
      } else {
        this.display = 'none'
      }
    },
    visibleF () {
      if (this.visibleF) {
        this.display = 'block'
      } else {
        this.display = 'none'
      }
    },
    'app.login': function (val) {
      if (val) {
        this.appActive = 'active'
      } else {
        this.appActive = ''
        this.dis.files = true
        this.dis.pkg = true
      }
    }
    // tableData: function (val) {
    //   if (this.state === 'upload' && this.tableData.length === 7) {
    //     this.tableData.splice(5, 1)
    //   }
    // }
  },
  props: [
    'type',
    'id',
    'name',
    'fileNum',
    'title',
    'time',
    'expire',
    'size',
    'notes',
    'nameNum',
    'weight',
    'percent',
    'state',
    'index',
    'timeWord',
    'downloadTimes',
    'imgUrl',
    'uploadPercent',
    'isActive',
    'isDelete',
    'userIdList',
    't_state',
    'userRole',
    'recordNum',
  ],
  data () {
    if (this.timeWord === '') {
      var timeWordClass = ''
    } else {
      timeWordClass = 'time'
    }
    if (this.index === 0) {
      var isTop = 'top'
    }
    if (this.expire.time !== '-' && this.expire.distance <= 2) {
      var expireInfo =
        this.$lang.ui.notice.l126.l0 +
        this.expire.distance +
        this.$lang.ui.notice.l126.l1
      var notesShow = false
    } else {
      expireInfo = ''
      notesShow = true
    }
    return {
      message: {
        Fl100: this.$lang.ui.form.l100,
        Fl101: this.$lang.ui.form.l101,
        Sl111: this.$lang.ui.system.l111,
        Sl112L1: this.$lang.ui.system.l112.l1,
        Sl112L2: this.$lang.ui.system.l112.l2,
        Sl113: this.$lang.ui.system.l113,
        Sl114: this.$lang.ui.system.l114,
        Sl115: this.$lang.ui.system.l115,
        Sl116: this.$lang.ui.system.l116,
        Sl117: this.$lang.ui.system.l117,
        Sl118: this.$lang.ui.system.l118,
        Sl207: this.$lang.ui.system.l207,
        Sl210: this.$lang.ui.system.l210,
        Al120: this.$lang.ui.app.l120,
        Sl211: this.$lang.ui.system.l211,
        Sl208: this.$lang.ui.system.l208
      },
      dis: {
        pkg: true,
        files: true
      },
      appActive: '',
      filesLoading: false,
      isTop: isTop,
      visibleA: false,
      visible: false,
      visibleB: false,
      visibleD: false,
      visibleE: false,
      visibleF: false,
      display: 'none',
      files: [],
      num: 1,
      total: 0,
      checkedList: [],
      shareList: [],
      timeWordClass: timeWordClass,
      expireInfo: expireInfo,
      addUserList: [],
      addUserListOld: [],
      userList: [],
      notesShow: notesShow,
      tipWord: this.$lang.ui.system.l209,
      schedule: false,
      delTaskId: '',
      isMy: false
    }
  },
  mounted () {
    // if (this.state !== 'download') {
    //   this.tableData.splice(5, 1)
    // }
    if (this.app.login) {
      this.appActive = 'active'
    } else {
      this.appActive = ''
      this.dis.files = true
      this.dis.pkg = true
    }
  },
  methods: {
    pageList () {
      this.filesList(this.id, this.state)
    },
    addActive () {
      this.checkedList = []
      this.$emit('removeActive')
      // if (this.isActive === '') {
      //   this.isActive = 'active'
      // } else {
      //   this.isActive = ''
      // }
    },
    appDownloadPkg () {
      if (this.app.login) {
        this.dis.pkg = false
      } else {
        this.$app.login(0, response => {
          if (response === 2) {
            this.$app.start()
          }
        })
      }
    },
    appDownloadFiles () {
      if (this.app.login) {
        this.dis.files = false
      } else {
        this.$app.login(0, response => {
          if (response === 2) {
            this.$app.start()
          }
        })
      }
    },
    filesList (id, state) {
      this.filesLoading = true
      this.files = []
      if (state === 'download') {
        var paramsData = {
          op: state,
          with_state: 1,
          page_num: this.num,
          page_size: 8,
          no_dir_empty: 1,
        }
      } else {
        paramsData = {
          op: state,
          with_sender: 1,
          with_state: 1,
          page_num: this.num,
          page_size: 8,
          no_dir_empty: 1,
        }
      }
      this.$http
        .get('/cydex/api/v1/packages/' + id + '/files', { params: paramsData })
        .then(response => {
          this.files = []
          this.total = response.data.total_num
          if (state === 'upload') {
            var fileState = 'upload'
          } else {
            fileState = 'download'
          }
          for (var i = 0; i < response.data.files.length; i++) {
            let percent = 0
            let fileData = response.data.files[i]
            if (state === 'download') {
              if (fileData.size !== 0) {
                percent = parseInt(
                  (
                    fileData.state.finished_size /
                    fileData.size
                  ) * 100, 10
                )
              } else {
                percent = fileData.state.state === 2 ? 100 : 0
              }
            } else {
              if (fileData.size !== 0) {
                percent = parseInt(
                  (
                    fileData.sender.finished_size /
                    fileData.size
                  ) * 100, 10
                )
              } else {
                percent = fileData.sender.state === 2 ? 100 : 0
              }
            }
            this.files.push({
              id: response.data.files[i].id,
              name: response.data.files[i].name,
              size: this._global.trafficSwitch(response.data.files[i].size),
              percent: percent,
              state: fileState
            })
          }
          this.filesLoading = false
        })
    },
    download (id) {
      this.visible = false
      var start = {
        taskType: 'download',
        start: 1,
        pkgId: id
      }
      if (this.userRole !== 1) {
        this.$app.newTask(start, response => {
          if (response.error === 0 || response.error === 100) {
            this.$message({
              message: this.$lang.ui.prompt.l109,
              type: 'success',
              duration: 4000
            })
            setTimeout(() => {
              this.$store.dispatch('transferEl', 'download')
              // this.$store.dispatch('showTransfer', {
              //   show: true,
              //   type: 'download'
              // })
            }, 200)
          } else {
            if (response.error === 4 || response.error === 104) {
              this.$message({
                message: this.$lang.ui.prompt.l110,
                type: 'warning'
              })
            }
          }
        })
      } else {
        this.$message({
          message: this.$lang.ui.prompt.l150.l0 + localStorage.getItem('projectName') + this.$lang.ui.prompt.l150.l2,
          type: 'error'
        })
      }
    },
    downloadFiles () {
      this.visibleB = false
      var fileList = []
      for (var a = 0; a < this.checkedList.length; a++) {
        fileList.push(this.checkedList[a].id)
      }
      var start = {
        taskType: this.state,
        start: 1,
        fileIds: fileList
      }
      this.$app.newTask(start, response => {
        if (response.error === 0 || response.error === 100) {
          this.$message({
            message: this.$lang.ui.prompt.l111,
            type: 'success',
            duration: 4000
          })
          setTimeout(() => {
            this.$store.dispatch('showTransfer', {
              show: true,
              type: 'download'
            })
          }, 1200)
        } else {
          if (response.error === 4 || response.error === 104) {
            this.$message({
              message: this.$lang.ui.prompt.l112,
              type: 'warning'
            })
          }
        }
      })
    },
    deletePkg (id) {
      this.visibleA = false
      // 收件箱
      if (this.type === 'receiver') {
        let params = {
          taskType: 'download',
          // taskFinish: 1,
          pkgId: id
        }
        // 包裹未在传输状态
        if (this.t_state !== 1) {
          // 助手未激活
          if (this.appActive === '') {
            var uid = localStorage.getItem('uid')
            this.$http.put('/cydex/api/v1/packages/' + id + '/recipients', {
              remove_users: [uid]
            })
              .then(response => {
                this.$message({
                  message: this.$lang.ui.prompt.l113,
                  type: 'success',
                  duration: 2000
                })
                this.$emit('deleteSuccess')
              })
          } else {
            // 助手已激活
            this.$app.pkgTransferTask(params, response => {
              if (response.tasks.length !== 0) {
                for (let value of response.tasks) {
                  if (value.packageId === id) {
                    this.delTaskId = value.taskId
                    this.$app.appDelete('download', this.delTaskId, response => {
                      if (response.error === 0 || response.error === 100) {
                        // this.$emit('deleteTaskSuccess')
                        var uid = localStorage.getItem('uid')
                        this.$http
                          .put('/cydex/api/v1/packages/' + id + '/recipients', {
                            remove_users: [uid]
                          })
                          .then(response => {
                            this.$message({
                              message: this.$lang.ui.prompt.l113,
                              type: 'success',
                              duration: 2000
                            })
                            this.$emit('deleteSuccess')
                          })
                      }
                    })
                  }
                }
              } else {
                var uid = localStorage.getItem('uid')
                this.$http.put('/cydex/api/v1/packages/' + id + '/recipients', {
                  remove_users: [uid]
                })
                  .then(response => {
                    this.$message({
                      message: this.$lang.ui.prompt.l113,
                      type: 'success',
                      duration: 2000
                    })
                    this.$emit('deleteSuccess')
                  })
              }
            })
          }
        } else {
          // 传输中且助手未激活
          if (this.appActive === '') {
            this.$message({
              message: this.$lang.ui.prompt.l167,
              type: 'warning',
              duration: 2000
            })
          } else {
            // 传输中且助手已激活
            this.$app.pkgTransferTask(params, response => {
              if (response.tasks.length !== 0) {
                for (let value of response.tasks) {
                  if (value.packageId === id) {
                    this.delTaskId = value.taskId
                    this.$app.appDelete('download', this.delTaskId, response => {
                      if (response.error === 0 || response.error === 100) {
                        // this.$emit('deleteTaskSuccess')
                        var uid = localStorage.getItem('uid')
                        this.$http
                          .put('/cydex/api/v1/packages/' + id + '/recipients', {
                            remove_users: [uid]
                          })
                          .then(response => {
                            this.$message({
                              message: this.$lang.ui.prompt.l113,
                              type: 'success',
                              duration: 2000
                            })
                            this.$emit('deleteSuccess')
                          })
                      }
                    })
                  }
                }
              } else {
                this.$message({
                  message: this.$lang.ui.prompt.l167,
                  type: 'warning',
                  duration: 2000
                })
              }
            })
          }
        }
      } else {
        // 发件箱
        let params = {
          taskType: 'upload',
          // taskFinish: '1',
          pkgId: id
        }
        // 包裹未在上传
        if (this.t_state !== 1) {
          // 助手未激活
          if (this.appActive === '') {
            this.$http.delete('/cydex/api/v1/packages/' + id).then(response => {
              this.$message({
                message: this.$lang.ui.prompt.l113,
                type: 'success',
                duration: 2000
              })
              this.$emit('deleteSuccess')
            })
          } else {
            // 包裹未上传，助手已激活
            this.$app.pkgTransferTask(params, response => {
              if (response.tasks.length !== 0) {
                for (let value of response.tasks) {
                  if (value.packageId === id) {
                    this.delTaskId = value.taskId
                    this.$app.appDelete('upload', this.delTaskId, response => {
                      if (response.error === 0 || response.error === 100) {
                        // this.$emit('deleteTaskSuccess')
                        this.$http.delete('/cydex/api/v1/packages/' + id).then(response => {
                          this.$message({
                            message: this.$lang.ui.prompt.l113,
                            type: 'success',
                            duration: 2000
                          })
                          this.$emit('deleteSuccess')
                        })
                      }
                    })
                  }
                }
              } else {
                // 包裹未上传，助手已激活但找不到task
                this.$http.delete('/cydex/api/v1/packages/' + id).then(response => {
                  this.$message({
                    message: this.$lang.ui.prompt.l113,
                    type: 'success',
                    duration: 2000
                  })
                  this.$emit('deleteSuccess')
                })
              }
            })
          }
        } else {
          // 包裹正在上传，助手未激活
          if (this.appActive === '') {
            this.$message({
              message: this.$lang.ui.prompt.l167,
              type: 'warning',
              duration: 2000
            })
          } else {
            // 包裹正在上传，助手已激活
            this.$app.pkgTransferTask(params, response => {
              if (response.tasks.length !== 0) {
                for (let value of response.tasks) {
                  if (value.packageId === id) {
                    this.delTaskId = value.taskId
                    this.$app.appStop('upload', this.delTaskId, response => {
                      if (response.error === 0 || response.error === 100) {
                        this.$app.appDelete('upload', this.delTaskId, response => {
                          if (response.error === 0 || response.error === 100) {
                            // this.$emit('deleteTaskSuccess')
                            this.$http.delete('/cydex/api/v1/packages/' + id).then(response => {
                              this.$message({
                                message: this.$lang.ui.prompt.l113,
                                type: 'success',
                                duration: 2000
                              })
                              this.$emit('deleteSuccess')
                            })
                          }
                        })
                      }
                    })
                  }
                }
              } else {
                // 包裹正在上传，助手已激活但找不到task
                this.$message({
                  message: this.$lang.ui.prompt.l167,
                  type: 'warning',
                  duration: 2000
                })
              }
            })
          }
        }
      }
    },
    checkedFiles (msg) {
      if (msg.checked) {
        this.checkedList.push({
          id: msg.id
        })
      } else {
        for (var i = 0; i < this.checkedList.length; i++) {
          if (this.checkedList[i].id === msg.id) {
            this.checkedList.splice(i, 1)
          }
        }
      }
    },
    getUserlist () {
      this.addUserList = []
      var id = localStorage.getItem('projectId')
      this.$http
        .get('/cydex/api/v1/projects/' + id + '/members', {
          params: {
            sort: 'name'
          }
        })
        .then(response => {
          this.userList = []
          this.users = []
          this.addUserListOld = []
          for (var i = 0; i < response.data.members.length; i++) {
            if (response.data.members[i].user_info.is_black_user === 0) {
              this.userList.push({
                name: response.data.members[i].user_info.name,
                id: response.data.members[i].user_info.id
              })
            }
          }
          for (var x = 0; x < this.userIdList.length; x++) {
            this.addUserList.push(this.userIdList[x].id)
            this.addUserListOld.push(this.userIdList[x].id)
          }
        })
    },
    getSharelist () {
      var e = {
        package_id: this.id
      }
      this.$api.getSharelist(e, response => {
        this.shareList = []
        for (var i = 0; i < response.user_list.length; i++) {
          this.shareList.push({
            name: response.user_list[i].name,
            url: response.user_list[i].url_pkg_download,
            tip: false
          })
        }
      })
    },
    copyTip (e) {
      var index = parseInt(e.trigger.getAttribute('buttonIndex'))
      this.shareList[index].tip = true
      setTimeout(() => {
        this.shareList[index].tip = false
      }, 800)
    },
    addUser () {
      var removeList = []
      var addList = []
      for (var i = 0; i < this.addUserListOld.length; i++) {
        if (!this._global.arrayHas(this.addUserList, this.addUserListOld[i])) {
          removeList.push(this.addUserListOld[i])
        }
      }
      for (var a = 0; a < this.addUserList.length; a++) {
        if (!this._global.arrayHas(this.addUserListOld, this.addUserList[a])) {
          addList.push(this.addUserList[a])
        }
      }
      if (this.addUserList.length === 0) {
        return
      }
      if (addList.length !== 0 || removeList.length !== 0) {
        this.$http
          .put('/cydex/api/v1/packages/' + this.id + '/recipients', {
            add_users: addList,
            remove_users: removeList
          })
          .then(() => {
            this.visibleD = false
            this.$emit('updateSuccess')
          })
      } else {
        this.visibleD = false
      }
    },
    scheduleShow (val) {
      this.schedule = val
    }
  }
}
</script>

<style scoped lang="css">
.pkg-main {
  position: relative;
}
.time-word {
  position: relative;
  width: 100%;
  height: 50px;
}
.time-word-cell {
  position: absolute;
  z-index: 1;
  color: #616161;
  text-align: left;
  top: 0;
  left: -10px;
  right: -10px;
  bottom: 0px;
  background-color: #fff;
}
.time-word-cell span {
  position: absolute;
  bottom: 12px;
  left: 31px;
}
.pkg-main.active .time-word-cell span {
  left: 41px;
}
.time-word-shadow {
  z-index: 2;
  position: absolute;
  border-top: 1px solid #e5e5e5;
  left: 0px;
  right: 0px;
  height: 1px;
  bottom: 0px;
  background-color: #fff;
}
.pkg-main.active .time-word-shadow {
  display: none;
}
.pkg-main.time .pkg-box {
  background-color: #fff;
}
.top .time-word-cell {
  top: -5px;
  z-index: 2;
}
.pkg-main.active {
  height: 480px;
  margin-left: -10px;
  margin-right: -10px;
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: #fff;
}
.pkg-main.active.top {
  padding-top: 0;
  height: 450px;
}
.pkg-main.time.active {
  height: 530px;
}
.pkg-main.time.active.top {
  height: 500px;
}
.pkg-main.active .pkg-box {
  z-index: 3;
  position: relative;
  overflow: hidden;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
}
.pkg {
  position: relative;
  z-index: 3;
  overflow: hidden;
  height: 50px;
  width: 100%;
  font-size: 15px;
  /* min-width: 620px; */
  line-height: 32px;
  background-color: #fff;
  cursor: pointer;
  color: #242729;
  text-align: left;
  padding: 9px 18px;
  border-bottom: 1px solid #e5e5e5;
}
.pkg-more {
  display: none;
  height: 0;
  background-color: #fff;
  overflow: hidden;
  transition: height 0.15s;
  width: 0px;
}
.fileList {
  position: relative;
  padding: 0 35px;
  height: 272px;
}
.pkg-main.active .pkg-more {
  display: block;
  position: relative;
  width: 100%;
  height: 370px;
  background-color: #fff;
}
.page {
  position: absolute;
  width: 100%;
  text-align: center;
  bottom: 15px;
}
.box-notes {
  width: 100%;
  text-align: left;
  padding: 15px 55px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pkg-img {
  position: relative;
  display: block;
  float: left;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  overflow: hidden;
}
.pkg-img img {
  position: absolute;
  left: 0;
  top: 0;
  width: 32px;
  height: 32px;
}
.pkg-name {
  float: left;
  display: flex;
  margin-left: 20px;
  width: 180px;
}
.name {
  float: left;
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.num {
  float: right;
  display: flex;
}
.pkg-title {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 280px;
  right: 400px;
  line-height: 48px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pkg-time {
  color: #666;
  width: 160px;
  float: right;
}
.pkg-size {
  color: #666;
  float: right;
  width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pkg-percent {
  margin: 7px 3px 7px 7px;
  width: 18px;
  height: 18px;
  float: right;
  line-height: 18px;
  text-align: center;
}
.notes {
  font-weight: 500;
  margin-left: 8px;
  color: #757575;
}
.notes.error {
  color: #d9534f;
  font-style: oblique;
}
.notes.waring {
  font-style: oblique;
  color: #f7ba2a;
}
.more {
  display: none;
  position: absolute;
  width: 220px;
  right: 0px;
  top: 9px;
  bottom: 9px;
  font-size: 19px;
  color: #666;
  background-color: #fff;
  line-height: 45px;
  padding-left: 15px;
}
.more .icon {
  padding: 0 10px;
}
.more .icon:hover {
  color: #242729;
}
.more .delete:hover {
  color: #d43f3a;
}
.pkg:hover .more {
  display: block !important;
}
.po-name {
  width: 100%;
  font-size: 14px;
  padding-left: 2px;
  color: #0291cf;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.check-files-list {
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 50px;
  padding: 0 60px;
  line-height: 60px;
  top: 0;
  background-color: #fff;
}
.button-download {
  float: left;
  line-height: 0;
  cursor: pointer;
  border-radius: 4px;
  display: block;
  margin-top: 10px;
  margin-left: 20px;
  overflow: hidden;
  font-size: 14px;
  padding: 16px 20px;
  color: #fff;
  background-color: #d9534f;
  border: 1px solid #d43f3a;
}
.pkg-main.delete .pkg {
  opacity: 0.5;
}
.pkg-main.active.delete .pkg {
  opacity: 1;
}
.appDownload {
  opacity: 0.6;
}
.appDownload.active {
  opacity: 1;
}
.share-cell {
  position: relative;
  padding: 5px 0;
}
.tip {
  position: absolute;
  z-index: 1;
  width: 70px;
  height: 30px;
  bottom: 5px;
  right: 0;
}
.check {
  padding: 12px 0;
  border: 1px solid #e6ebf5;
  border-top: 0px;
  text-align: center;
}
.check span {
  cursor: pointer;
  color: #007bc5;
}
.check span:hover {
  font-weight: 600;
}
.info-main {
  max-height: 338px;
}
.info-main .cell {
  padding: 8px 5px;
}
.info-main .cell .name {
  width: 180px;
}
.schedule {
  position: relative;
  width: 95%;
  height: 80px;
}
</style>
